// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".restaurant-cta-list[data-v-4a41e3d0]{display:grid;grid-gap:60px;justify-items:center}@media(min-width:576px){.restaurant-cta-list[data-v-4a41e3d0]{display:grid;grid-template-columns:repeat(2,auto)}}@media(min-width:992px){.restaurant-cta-list[data-v-4a41e3d0]{grid-template-columns:repeat(3,auto)}}@media(min-width:1377px){.restaurant-cta-list[data-v-4a41e3d0]{grid-template-columns:repeat(4,auto)}}.restaurant-cta[data-v-4a41e3d0]{max-width:300px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
